import React from "react";
import { images } from "../../../constants";
import "./CardVisaPublic.scss";

const CardVisaPublic = ({visa}) => {
  return (
    <div className="visa-public-card">
      <div className="card__visa--heading">
        <div className="card__visa--img">
          <img src={images.logoVisa} alt="" />
        </div>
        <div>
          <h2 className="title-gray-bold-22">{visa.name}</h2>
          <h2 className="paragraph-gray-reg-20">{visa.subname}</h2>
        </div>
      </div>
      <div className="content-info">
        <span className="paragraph-gray-reg-20">Visa fee</span>
        <span className="paragraph-gray-bold-20">A$ {visa.visafee}</span>
      </div>
      <div className="content-info">
        <span className="paragraph-gray-reg-20">Extra fee</span>
        <span className="paragraph-gray-bold-20"> A$ {visa.extrafee}</span>
      </div>
      <div className="content-info">
        <span className="paragraph-gray-reg-20">Total</span>
        <span className="paragraph-gray-bold-20"> A$ {visa.total}</span>
      </div>
    </div>
  );
};

export default CardVisaPublic;
